import { render, staticRenderFns } from "./ClassesTable.vue?vue&type=template&id=b6229e44&scoped=true&"
import script from "./ClassesTable.vue?vue&type=script&lang=ts&"
export * from "./ClassesTable.vue?vue&type=script&lang=ts&"
import style0 from "./ClassesTable.vue?vue&type=style&index=0&id=b6229e44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6229e44",
  null
  
)

export default component.exports